export const tokens = {
  common: {
    loading: 'common.loading',
    rowPerPage: 'common.rowPerPage',
    sortBy: 'common.sortBy',
    back: 'common.back',
    cancel: 'common.cancel',
    cantEdit: 'common.cantEdit',
    actions: 'common.actions',
    accept: 'common.accept',
    reject: 'common.reject',
    edit: 'common.edit',
    title: 'common.title',
    car: 'common.car',
    search: 'common.search',
    filters: 'common.filters',
    close: 'common.close',
    noFilters: 'common.noFilters',
  },

  load: {
    create: {
      title: 'load.create.title',
      basicInformationTitle: 'load.create.basicInformationTitle',
      equipmentTitle: 'load.create.equipmentTitle',
      shipperName: 'load.create.shipperName',
      specificDeliveryTime: 'load.create.specificDeliveryTime',
      submit: 'load.create.submit',
      addLoadItem: 'load.create.addLoadItem',
    },
  },
  login: {
    title: 'login.title',
    usernameLabel: 'login.usernameLabel',
    PasswordLabel: 'login.PasswordLabel',
    ForgetPasswordQuestion: 'login.ForgetPasswordQuestion',
    submit: 'login.submit',
  },
  changeRoleCarrier: {
    title: 'login.changeRoleCarrier',
    usernameLabel: 'login.usernameLabel',
    PasswordLabel: 'login.PasswordLabel',
    ForgetPasswordQuestion: 'login.ForgetPasswordQuestion',
    submit: 'login.submit',
  },

  forgetPassword: {
    title: 'forgetPassword.title',
    EmailLabel: 'forgetPassword.EmailLabel',
    BackLabel: 'forgetPassword.BackLabel',
    submit: 'forgetPassword.submit',
  },
  validation: {
    email: 'validation.email',
    emailRequired: 'validation.emailRequired',
    passwordRequired: 'validation.passwordRequired',
    firstNameRequired: 'validation.firstNameRequired',
    lastNameRequired: 'validation.lastNameRequired',
    mobileRequired: 'validation.mobileRequired',
    nicknameRequired: 'validation.nicknameRequired',
    amountRequired: 'validation.amountRequired',
    required: 'validation.required',
  },

  error: {
    retry: 'error.retry',
  },

  nav: {
    overview: 'nav.overview',
  },
};
